import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { Typography, CircularProgress } from '@material-ui/core'
import { Divider } from '@mui/material'
import * as Modal from '_components/modal/generic-modal'

import useStyles from './styles'

const MoreDetailsModal = ({
  open,
  onClose,
  title,
  fetchData,
  fetchKey,
  renderContent,
  children,
  okText,
}) => {
  const styles = useStyles()
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (open) return
    setLoading(false)
    setData(null)
    setError(null)
  }, [open])

  useEffect(() => {
    if (!open || !fetchData) return undefined

    let canceled = false
    setLoading(true)
    setError(null)
    ;(async () => {
      try {
        const response = await fetchData()
        if (canceled) return
        setData(response)
      } catch (err) {
        if (canceled) return
        setError(err)
      } finally {
        if (!canceled) setLoading(false)
      }
    })()

    return () => {
      canceled = true
    }
  }, [open, fetchData, fetchKey])

  const body = useMemo(() => {
    if (loading) {
      return (
        <div className={styles.loading}>
          <CircularProgress />
        </div>
      )
    }

    if (renderContent) return renderContent({ data, error })
    if (children) return children

    if (error) return <Typography>Não foi possível carregar os detalhes.</Typography>
    return <Typography>Nenhum detalhe encontrado.</Typography>
  }, [children, data, error, loading, renderContent, styles.loading])

  if (!open) return null

  return (
    <Modal.Root
      open={open}
      onClose={onClose}
      disableBackdropClick
      disableEscapeKeyDown
      className={styles.modal}
    >
      <Modal.TitleModal title={title} />
      <Divider className={styles.divider} />
      <Modal.Content className={styles.content}>{body}</Modal.Content>
      <Modal.Actions className={styles.actions}>
        <Modal.ButtonFullBlue onClick={onClose}>{okText}</Modal.ButtonFullBlue>
      </Modal.Actions>
    </Modal.Root>
  )
}

MoreDetailsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  fetchData: PropTypes.func,
  fetchKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  renderContent: PropTypes.func,
  children: PropTypes.node,
  okText: PropTypes.string,
}

MoreDetailsModal.defaultProps = {
  title: 'Mais detalhes',
  fetchData: null,
  fetchKey: undefined,
  renderContent: null,
  children: null,
  okText: 'Fechar',
}

export default MoreDetailsModal
